import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../../software-dynamic-version-2/mainSection-multiple-inputs-v-2';
import IrtizaDynamicInputGrid from '../../software-dynamic-version-2/popup-input-grid-v-2';
import DialogInput from '../../software-dynamic-version-2/popup-dialog-input-v-2';



import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { AutoCompleteComponent } from '@syncfusion/ej2-react-dropdowns';
import BudgetingService from './Budgeting.service';
import Moment from 'react-moment';
import SecurityService from '../../security/security.service';
import AuditTableInput from '../../audit-table/audit-table';

const BudgetingAdd = (props) => {
  console.log(props);

  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};
  
  const [inputProps, setInputProps] = useState({
    CallGridDataSource: { name: 'CallGridDataSource', value: props.isAdd == false },
    GridsDataSources: { name: 'GridsDataSources', value: []},
    SelectRowByID: { name: 'SelectRowByID', value: undefined },
    PopupMode: { name: 'PopupMode', value: props.isAdd  == true ? 'ADD' : 'EDIT'},
    // SIDE MAIN SECTION
    EntryID: { name: 'EntryID', value: props.EntryID || undefined },
    EntryDate: { name: 'EntryDate', caption : 'Budgeting Date',value: props.EntryDate || 'currentDate' },
    CustomerOrderNo: {
      name: { id: 'ExportOrderNo', value: 'CustomerOrderNo' },
      caption: 'Export Order No.',
      value: { id: props.ExportOrderNo || undefined, value: props.CustomerOrderNo || '' },
      dataSource: { type: 'Route', route: 'BudgetingExportOrder' },
    },
    
    // LEFT MAIN SECTION
    AName: { name: 'AName',caption:'Customer Name', labelType:'Always', value: props.AName || '' ,enabled:false},
    ShipmentDate: { name: 'ShipmentDate', caption:'Shipment Date' ,labelType:'Always', value: props.ShipmentDate || 'currentDate' ,enabled:false},
    ExportOrderDate: { name: 'ExportOrderDate',caption:'Order Date', labelType:'Always',value: props.ExportOrderDate || 'currentDate' ,enabled:false},
    TotalTowelQuantity: { name: 'TotalTowelQuantity',caption:'Order Quantity', labelType:'Always',value: props.TotalTowelQuantity || '' ,enabled:false},
    TotalOrderAmountFC: { name: 'TotalOrderAmountFC',caption:'Order Amount', labelType:'Always',value: props.TotalOrderAmountFC || '' ,enabled:false},
    OrderExchangeRate: { name: 'OrderExchangeRate',caption:'Exchange Rate', labelType:'Always',value: props.OrderExchangeRate || '' ,decimal:2,enabled:false},
    TotalOrderAmountRS: { name: 'TotalOrderAmountRS',caption:'Order Amount RS', labelType:'Always',value: props.TotalOrderAmountRS || '' ,enabled:false},
    
    // Additional Budget Fields
    Yarn: { name: 'Yarn', value: props.Yarn || 0 ,decimal:0,enabled:false},
    Weaving: { name: 'Weaving', value: props.Weaving || 0 ,decimal:0,enabled:false},
    Dyeing: { name: 'Dyeing', value: props.Dyeing || 0 ,decimal:0,enabled:false},
    Shearing: { name: 'Shearing', value: props.Shearing || 0 ,decimal:0,enabled:false},
    Stitching: { name: 'Stitching', value: props.Stitching || 0 ,decimal:0,enabled:false},
    Accessory: { name: 'Accessory', value: props.Accessory || 0 ,decimal:0,enabled:false},
    Packing: { name: 'Packing', value: props.Packing || 0 ,decimal:0,enabled:false},
    Expense: { name: 'Expense', value: props.Expense || 0 ,decimal:0,enabled:false},
    EstimatedExpenses: { name: 'EstimatedExpenses', value: props.EstimatedExpenses || 0  ,decimal:0,enabled:false},
    EstimatedPL: { name: 'EstimatedPL', caption:'Estimated P/L' , value: props.EstimatedPL || 0 ,decimal:0,enabled:false},
    CostButton :{ name:'Cost', enabled:true}
  });
  
// EXTRA CODE START
const SaveButton = (GridID ,visibility)=>{
  document.querySelector(`#${GridID}Grid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat`).style.visibility = `${visibility}`;
}
useEffect(()=>{
  console.log('irtiz',inputProps.GridsDataSources.value)
  if( props.isAdd == true || inputProps.PopupMode.value == 'ADD'){
  setTimeout(()=>{SaveButton(props.GridID , inputProps.GridsDataSources.value.length > 0 && inputProps.CustomerOrderNo.value.id != undefined  ? 'visible' : 'hidden' )},1000)
  }
}, [inputProps.GridsDataSources.value ])

let getYarnCalculation = (id)=>{
  let data = {
    ExportOrderNo :id,
    ToDate: inputProps.EntryDate.value || moment().format('DD-MMM-YY')
  }
  console.log(data)
  BudgetingService.yarnDetailSummary(data).then((response)=>{
    console.log(response);
    const totalYarnCost =  response.data.recordset.reduce((sum, item) => {
      return sum + (parseFloat(item.YarnRequiredCost) || 0);
    }, 0);
    setInputProps((prevValues) => ({
      ...prevValues,
      ['Yarn']: {...prevValues['Yarn'] ,value :totalYarnCost || 0  },
    }));
  })
}
let getOtherCalculation = (id)=>{
  let data = {
    ExportOrderNo : id,
    ToDate: inputProps.EntryDate.value || moment().format('DD-MMM-YY')
  }
  console.log(data)
  BudgetingService.calculationSummary(data).then((response)=>{
    console.log(response);
    // WeavingCost ,ShearingCost ,StitchingCostPlusBPercent ,DyeingCost
    setInputProps((prevValues) => ({
      ...prevValues,
      ['Weaving']: {...prevValues['Weaving'] ,value :Math.ceil(response.data.recordset[0].WeavingCost) || 0  },
      ['Shearing']: {...prevValues['Shearing'] ,value :Math.ceil(response.data.recordset[0].ShearingCost) || 0  },
      ['Stitching']: {...prevValues['Stitching'] ,value :Math.ceil(response.data.recordset[0].StitchingCostPlusBPercent) || 0  },
      ['Dyeing']: {...prevValues['Dyeing'] ,value :Math.ceil(response.data.recordset[0].DyeingCost) || 0  },
    }));

  
  })
}
let getGridSum = (data, grid)=>{
  const totalAmount = data.reduce((sum, item) => {
    return sum + (parseFloat(item.Amount) || 0);
  }, 0);
  setInputProps((prevValues) => ({
    ...prevValues,
    ['Expense']: {...prevValues['Expense'] ,value :grid ==3 ? Math.ceil(totalAmount):prevValues['Expense'].value  },
    ['Packing']: {...prevValues['Packing'] ,value :grid ==2 ? Math.ceil(totalAmount):prevValues['Packing'].value  },
    ['Accessory']: {...prevValues['Accessory'] ,value :grid ==1 ? Math.ceil(totalAmount):prevValues['Accessory'].value  },
    
  }));
 
}

let getUpperSummaryCalculation = (id,date)=>{
  let data = {
    ExportOrderNo : id,
    ToDate: date || inputProps.EntryDate.value || moment().format('DD-MMM-YY')
  }
  console.log(data)
  BudgetingService.upperCalculationSummary(data).then((response)=>{
    console.log(response);
    setInputProps((prevValues) => ({
      ...prevValues,
      ['AName']: {...prevValues['AName'] ,value :response.data.recordset[0]?.AName || '' },
      ['ShipmentDate']: {...prevValues['ShipmentDate'] ,value :response.data.recordset[0]?.ShipmentDate || props.ShipmentDate },
      ['ExportOrderDate']: {...prevValues['ExportOrderDate'] ,value :response.data.recordset[0]?.ExportOrderDate || props.ExportOrderDate },
      ['TotalTowelQuantity']: {...prevValues['TotalTowelQuantity'] ,value :response.data.recordset[0]?.TotalTowelQuantity || 0 },
      ['TotalOrderAmountFC']: {...prevValues['TotalOrderAmountFC'] ,value :response.data.recordset[0]?.TotalOrderAmountFC || 0 },
      ['OrderExchangeRate']: {...prevValues['OrderExchangeRate'] ,value :parseFloat(response.data.recordset[0]?.OrderExchangeRate).toFixed(2) || 0.00 },
      ['TotalOrderAmountRS']: {...prevValues['TotalOrderAmountRS'] ,value :response.data.recordset[0]?.TotalOrderAmountRS || 0 },

    }));
  
  })
}

useEffect(()=>{
  setTimeout(() => {
    getEstimatedExpensesCalculation()
  }, 1000);
},[ inputProps.Yarn.value , inputProps.Weaving.value ,inputProps.Dyeing.value ,inputProps.Shearing.value ,inputProps.Stitching.value ,inputProps.Accessory.value, inputProps.Packing.value,inputProps.Expense.value ])

let getEstimatedExpensesCalculation = ()=>{
  setTimeout(() => {
    
    console.log(inputProps);
    let EstimatedExpenses =  inputProps.Yarn.value + inputProps.Weaving.value + inputProps.Dyeing.value + inputProps.Shearing.value + inputProps.Stitching.value + inputProps.Accessory.value + inputProps.Packing.value + inputProps.Expense.value
    console.log(EstimatedExpenses);
    
    setInputProps((prevValues) => ({
      ...prevValues,
      ['EstimatedExpenses']: {...prevValues['EstimatedExpenses'] ,value :EstimatedExpenses || 0  },
      ['EstimatedPL']: {...prevValues['EstimatedPL'] ,value :inputProps.TotalOrderAmountRS.value - EstimatedExpenses  || 0  },
    }));
  }, 1500);
}


let CallGridDataSources = ()=>{
  setInputProps((prevValues) => ({
    ...prevValues,
    ['CallGridDataSource']: {...prevValues['CallGridDataSource'] ,value :true}
  }));
  setTimeout(() => {
    
    setInputProps((prevValues) => ({
      ...prevValues,
      ['CallGridDataSource']: {...prevValues['CallGridDataSource'] ,value :false}
    }));
  }, 300);
}

// EXTRA CODE END
 
const handleInputCreated = async (e, name) => {
  if(name == 'EntryDate'){
    setTimeout(() => {
      document.getElementById('EntryDate').focus()
      document.getElementById('EntryDate').select()
    }, 10);
  }
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {
  if(name == 'CustomerOrderNo' && value.id != undefined){
    // setTimeout(()=>getUpperSummaryCalculation(value.id),500)
    setTimeout(()=>{
      getYarnCalculation(value.id)
      getOtherCalculation(value.id)
      getUpperSummaryCalculation(value.id, inputProps.EntryDate.value)
    },800)
   
}
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
  console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
  
const handleInputClick = async  ( name) => {
    console.log(name);
    if(name == 'Cost'){
      if(inputProps.GridsDataSources.value.length > 0){
        BudgetingService.addWithDetail(
          {
            EntryID:inputProps.EntryID.value,
            EntryDate:inputProps.EntryDate.value,
            ExportOrderNo:inputProps.CustomerOrderNo.value.id,
            CreationDate:moment().format('DD-MMM-YY'),
            CreatedByUserID:SecurityService.getLoggedInUserId(),
            UpdationDate:null,
            UpdatedByUserID:null,
            PrintedByDate:null,
            PrintedByUserID:null,
            ApprovedByUserID:null,
            ApprovedByDate:null,
            CompanyID:1,
            details :inputProps.GridsDataSources.value,
            UpdatedByUserID:SecurityService.getLoggedInUserId()}).then((res)=>{
          console.log(res)
          setInputProps((prevValues) => ({
            ...prevValues,
            ['EntryID']: {...prevValues['EntryID'] ,value :res.data.EntryID}
          }));
          setTimeout(()=>CallGridDataSources(),600)
          AuditTableInput.auditAdd('BudgetingMain','BudgetingMain','EntryID',{
            EntryDate:inputProps.EntryDate.value,
            CustomerOrderNo:inputProps.CustomerOrderNo.value.value
          })
          inputProps.GridsDataSources.value.map((res)=>{
            AuditTableInput.auditAdd('BudgetingDetail','BudgetingDetail','BudgetingDetailID',{
              BudgetItem: res.BudgetItem || '',
              Quantity: res.Quantity || 0,
              Rate: res.Rate || 0,
              Percentage: res.Percentage || 0,
              Amount: res.Amount || 0,
              ActualAmount: res.ActualAmount || 0
              
            })

          })

         
          }).catch(async(e)=>{
            // CallGridDataSources()
            await showDialog('WARNING' ,<span class="error-success">Please Try Again records not saved!</span> , ['OK'])

            console.log(e)
          })
      
      }else{
        await showDialog('WARNING' ,<span class="error-success">Please Fill Data In Grid!</span> , ['OK'])
      }
    }
  };
 
  let inputsList = [
    {Input: HiddenComponent ,Props: {...inputProps.EntryID, setInputProps },ColumnSize:0},

    {Input: DateComponent ,Props: {...inputProps.EntryDate, setInputProps,onCreated:handleInputCreated }},
    
    {Input: DropdownComponent ,Props: {...inputProps.CustomerOrderNo, onChange:handleInputChange,setInputProps },ColumnSize:6}
  ];
  let inputsCalculationList = [
   
    {Input: TextComponent,Props: {...inputProps.AName, setInputProps },ColumnSize:12},
    {Input: DateComponent,Props: {...inputProps.ShipmentDate, setInputProps },ColumnSize:12},
    {Input: DateComponent,Props: {...inputProps.ExportOrderDate, setInputProps },ColumnSize:12},
    {Input: NumberComponent,Props: {...inputProps.TotalTowelQuantity, setInputProps },ColumnSize:12},
    {Input: NumberComponent,Props: {...inputProps.TotalOrderAmountFC, setInputProps },ColumnSize:12},
    {Input: NumberComponent,Props: {...inputProps.OrderExchangeRate, setInputProps },ColumnSize:12},
    {Input: NumberComponent,Props: {...inputProps.TotalOrderAmountRS, setInputProps },ColumnSize:12},

    {Input: (e)=><h3></h3>,Props: {name:'space', setInputProps },ColumnSize:12},

    {Input: NumberComponent,Props: {...inputProps.Yarn, setInputProps },ColumnSize:12},
    {Input: NumberComponent,Props: {...inputProps.Weaving, setInputProps },ColumnSize:12},
    {Input: NumberComponent,Props: {...inputProps.Dyeing, setInputProps },ColumnSize:12},
    {Input: NumberComponent,Props: {...inputProps.Shearing, setInputProps },ColumnSize:12},
    {Input: NumberComponent,Props: {...inputProps.Stitching, setInputProps },ColumnSize:12},
    {Input: NumberComponent,Props: {...inputProps.Accessory, setInputProps },ColumnSize:12},
    {Input: NumberComponent,Props: {...inputProps.Packing, setInputProps },ColumnSize:12},
    {Input: NumberComponent,Props: {...inputProps.Expense, setInputProps },ColumnSize:12},
    {Input: NumberComponent,Props: {...inputProps.EstimatedExpenses, setInputProps },ColumnSize:12},
    {Input: NumberComponent,Props: {...inputProps.EstimatedPL, setInputProps },ColumnSize:12},

    {Input: props.isAdd ==  true  || inputProps.PopupMode.value == 'ADD' ? HiddenComponent :  HiddenComponent,Props: {...inputProps.CostButton, setInputProps , onClick:handleInputClick},ColumnSize:props.isAdd ==  true ? 4:0},

  ];

// Detail Section Start



const callGridDataSource = (id)=>{
  console.log('iri')
  return  BudgetingService.getBudgetingDetailForList(inputProps.EntryID.value ,id)
}

useEffect(()=>{
if(props.isAdd == false || inputProps.PopupMode.value == 'EDIT'){
  setTimeout(()=>{
    getYarnCalculation(props.ExportOrderNo)
    getOtherCalculation(props.ExportOrderNo)
    getUpperSummaryCalculation(props.ExportOrderNo,props.EntryDate )
  },500)
  
  setInputProps((prevValues) => ({
    ...prevValues,
    ['CallGridDataSource']: {...prevValues['CallGridDataSource'] ,value :false}
  }));


}

},[])



const dialogRef = useRef(null);
const showDialog = (header,title,actions =['OK']) => {
  return new Promise((resolve) => {
  // Destroy existing dialog if any
  if (dialogRef.current) {
    dialogRef.current.destroy();
  }
  const okButtons = actions.map((action) => ({
    buttonModel: {
      content: action,
      cssClass: 'e-flat',
      isPrimary: action === 'OK',
    },
    click: (e) => {
      hideDialog();
      resolve(action);
    },
  }));
  // Create a new dialog instance
  dialogRef.current = new DialogInput({
    content: ()=>(<>{title}</>),
    header:header,
    width:'340px',
    showButtons: true,
    buttons:okButtons
  });
  // Show the dialog programmatically
  dialogRef.current.show();

});

};
const hideDialog = () =>{
if (dialogRef.current) {
}
dialogRef.current.hide();
dialogRef.current.destroy();
dialogRef.current = null; // Clean up reference after destruction
}
const toolbarClicking =  async (grid , args , selectedRow , getListService,setDataSourceState)=>{
  console.log(args)
  console.log(selectedRow)
  if(args?.IsDeletedComplete == true){
    setTimeout(() => {
      setDataSourceState((data)=>{
        console.log(data)
  // let filterData =  data.filter((obj, index) =>  obj.SerialNo !=  selectedRow.SerialNo)
  
  getGridSum(data , selectedRow?.GridNo)

  return data;
  })
      console.log(inputProps.CustomerOrderNo.value)
      getYarnCalculation(inputProps.CustomerOrderNo.value.id)
  getOtherCalculation(inputProps.CustomerOrderNo.value.id)
  getUpperSummaryCalculation(inputProps.CustomerOrderNo.value.id,inputProps.EntryDate.value)
    }, 1500);
}
  if(args?.item?.properties?.id == 'DeleteAdd'){
    let dialogResult  = await showDialog('Confirmation' ,<span class="error-success">Are you sure you want to delete?</span> , ['OK','CANCEL'])
        console.log(dialogResult)
      if(dialogResult == 'OK'){
        
        await  showDialog('ALERT' ,<span class="error-success">RECORD(S) DELETED SUCESSFULLY</span>)
        setDataSourceState((data)=>{
          console.log(data)
    let filterData =  data.filter((obj, index) =>  obj.SerialNo !=  selectedRow.SerialNo)
    console.log(filterData);
    getGridSum(filterData ,selectedRow?.GridNo)

    return filterData;
    })
    setTimeout(() => {
      // Extract the current data source
      const currentData = inputProps.GridsDataSources.value;
    
      // Filter data based on condition
      const filteredData = currentData.filter(
        (res) => res.GridNo !== selectedRow.GridNo || res.SerialNo !== selectedRow.SerialNo
      );
    
      // Log filtered data
      console.log(filteredData);
    
      // Update state with filtered data
      setInputProps((prevValues) => ({
        ...prevValues,
        GridsDataSources: {
          ...prevValues.GridsDataSources,
          value: filteredData,  // Set to filtered data instead of an empty array
        },
      }));
      
    
      // Send filtered data via props
      props.sendDetails(filteredData);
    
    }, 1000);
    setTimeout(() => {
      getYarnCalculation(inputProps.CustomerOrderNo.value.id)
  getOtherCalculation(inputProps.CustomerOrderNo.value.id)
  getUpperSummaryCalculation(inputProps.CustomerOrderNo.value.id, inputProps.EntryDate.value)
    }, 1500);
    setTimeout(() => {
      console.log(inputProps.GridsDataSources.value)
    }, 2000);
        }
  }
}

const addActionComplete = async (grid, args ,setDataSourceState ,getListService  , selectedRow ,selectRowByID,startEdit  , addUserLog,editUserLog  )=>{
    
  console.log(selectedRow)
  console.log(args)
  console.log(grid)
  if(args.requestType == 'add' || args.requestType == 'beginEdit'){
    setTimeout(()=>{SaveButton(props.GridID ,'hidden')},1000)

    if(args.requestType == 'add'){
      if(document.getElementById('BudgetingPackingItemDetailGridAmount') ){
        document.getElementById('BudgetingPackingItemDetailGridAmount').value = 0
      }
      if(document.getElementById('BudgetingExpenseDetailGridAmount') ){
        document.getElementById('BudgetingExpenseDetailGridAmount').value = 0
      }
      if(document.getElementById('BudgetingAccessoryDetailGridAmount')  ){
        document.getElementById('BudgetingAccessoryDetailGridAmount').value = 0
      }
    }

    const updateAmountQuantity = (gridID)=>{
              console.log(gridID)
      let Qty = parseInt(document.getElementById(`${gridID}Quantity`).value.replace(/,/g, ''))   
      let Rate = parseInt(document.getElementById(`${gridID}Rate`).value.replace(/,/g, ''))   
      let Amounts = Qty * Rate;
      document.getElementById(`${gridID}Amount`).value = Amounts.toLocaleString();
      args.rowData.Amount = Amounts 

    }
       
    const updateAmountQuantityGrid3 = ()=>{
              
      let Qty = parseInt(document.getElementById(`BudgetingExpenseDetailGridQuantity`).value.replace(/,/g, ''))   
      let Rate = parseInt(document.getElementById(`BudgetingExpenseDetailGridPercentage`).value.replace(/,/g, ''))   
      let Amounts = Qty * Rate;
      document.getElementById(`BudgetingExpenseDetailGridAmount`).value = Amounts.toLocaleString();
      args.rowData.Amount = Amounts 
    // args.form[7].ej2_instances[0].value = Amounts;

       
      }
    
    document.getElementById('BudgetingAccessoryDetailGridQuantity')?.addEventListener('keydown', ()=>updateAmountQuantity('BudgetingAccessoryDetailGrid'))
    document.getElementById('BudgetingAccessoryDetailGridRate')?.addEventListener('keydown', ()=>updateAmountQuantity('BudgetingAccessoryDetailGrid'))
    
    document.getElementById('BudgetingExpenseDetailGridQuantity')?.addEventListener('keydown', ()=>{
      if(document.getElementById(`BudgetingExpenseDetailGridPercentage`)?.value > 0){
        updateAmountQuantityGrid3()
      }else{
        updateAmountQuantity('BudgetingExpenseDetailGrid')
      }
    }
    )
    document.getElementById('BudgetingExpenseDetailGridRate')?.addEventListener('keydown', ()=>updateAmountQuantity('BudgetingExpenseDetailGrid'))
    
    document.getElementById('BudgetingPackingItemDetailGridQuantity')?.addEventListener('keydown', ()=>updateAmountQuantity('BudgetingPackingItemDetailGrid'))
    document.getElementById('BudgetingPackingItemDetailGridRate')?.addEventListener('keydown', ()=>updateAmountQuantity('BudgetingPackingItemDetailGrid'))
    
    document.getElementById('BudgetingExpenseDetailGridPercentage')?.addEventListener('keydown', ()=>updateAmountQuantityGrid3())







    document.getElementById('BudgetingAccessoryDetailGridRate')?.addEventListener('blur', async (e)=>{
      setTimeout(() => document.getElementById('BudgetingAccessoryDetailGridRate')&& document.getElementById('BudgetingAccessoryDetailGrid_update').click(), 200);
    })
    document.getElementById('BudgetingExpenseDetailGridActualAmount')?.addEventListener('blur', async (e)=>{
      setTimeout(() => document.getElementById('BudgetingExpenseDetailGridActualAmount') && document.getElementById('BudgetingExpenseDetailGrid_update').click(), 200);
    })
    
    document.getElementById('BudgetingPackingItemDetailGridRate')?.addEventListener('blur', async (e)=>{
      setTimeout(() => document.getElementById('BudgetingPackingItemDetailGridRate') && document.getElementById('BudgetingPackingItemDetailGrid_update').click(), 200);
    })
    
    console.log(args)
   
  }
  
  console.log(inputProps)
    console.log(args)
  console.log(selectedRow)

  if(args.requestType == 'save' || args.requestType == 'cancel' ){
    setTimeout(()=>{SaveButton(props.GridID ,'visible')},1000)
  }
  if(args.requestType == 'save' ){
    
    let inputProp = {}
        setInputProps((prevValues) => {
          console.log(prevValues);
          inputProp = prevValues
          return {...prevValues
         }});
    console.log(inputProp)
  
    if (args.action == 'add' && (props.isAdd == true || inputProp.PopupMode.value == 'ADD')) { 
  
  setDataSourceState(prevArray => {
    // Create the new row based on the current length of the array
    const newRow = {
      GridNo: args.data.GridNo || prevArray.length + 1, // Assign GridNo dynamically if not provided
      SerialNo: prevArray.length + 1, // Correct SerialNo assignment
      BudgetItemID: args.data.BudgetItemID || '',
      BudgetItem: args.data.BudgetItem || '',
      Quantity: args.data.Quantity || 0,
      Rate: args.data.Rate || 0,
      Percentage: args.data.Percentage || 0,
      Amount: args.rowData.Amount || 0,
      ActualAmount: args.data.ActualAmount || 0,
    };
  
    let filterData =  [...prevArray].filter((res)=> res.SerialNo != null)
    const updatedArray = [...filterData, newRow];
  
    // Recalculate SerialNo for all rows to ensure it's sequential
    const recalculatedArray = updatedArray.map((item, index) => ({
      ...item,
      SerialNo: index + 1, // Ensure sequential SerialNo
    }));
  
    // Log to verify the updated array
    console.log('Updated Array:', recalculatedArray);
    console.log('storeGridDetails Array:', inputProp.GridsDataSources.value);
  
     let filterDatas = inputProp.GridsDataSources.value.filter((res)=> res.GridNo != args.data.GridNo);
    let sendDetailsData = [...filterDatas , ...recalculatedArray];
    console.log(sendDetailsData)
    setInputProps((prevValues) =>({
      ...prevValues,
      ['GridsDataSources'] : {...prevValues['GridsDataSources'] ,value:sendDetailsData}
    })); 
     props.sendDetails(sendDetailsData)
    
     getGridSum(recalculatedArray , recalculatedArray[0].GridNo)

    return recalculatedArray; // Return the corrected array
  });
  // getYarnCalculation(inputProp.CustomerOrderNo.value.id)
  // getOtherCalculation(inputProp.CustomerOrderNo.value.id)
  // getUpperSummaryCalculation(inputProp.CustomerOrderNo.value.id)

   setTimeout(() => {
   let gridId =  args.data.GridNo ==1 ? "BudgetingAccessoryDetail" :  args.data.GridNo ==2 ? "BudgetingPackingItemDetail" : "BudgetingExpenseDetail"
    document.getElementById(`${gridId}Grid_add`).click()
  }, 500);
}

if(args.action == 'edit' && (props.isAdd == true || inputProp.PopupMode.value == 'ADD')){
  setTimeout(() => {
    
  
  setDataSourceState((prevArray) => {
console.log(args)
    // Map through the array and update the specified row
let data =  prevArray.map((obj, index) => 
      // index === args.rowIndex 
obj.SerialNo ==  args.data.SerialNo
        ? { 
            ...obj,
            GridNo: args.data?.GridNo || obj.GridNo, // Preserve old value if new data is undefined
            BudgetItemID: args.data?.BudgetItemID || obj.BudgetItemID || '',
            BudgetItem: args.data?.BudgetItem || obj.BudgetItem || '',
            Quantity: args.data?.Quantity || obj.Quantity || 0,
            Rate: args.data?.Rate || obj.Rate || 0,
            Percentage: args.data?.Percentage || obj.Percentage || 0,
            Amount: args.rowData?.Amount || obj.Amount || 0,
            ActualAmount: args.data?.ActualAmount || obj.ActualAmount || 0,
          } 
        : obj
    );
    getGridSum(data , data[0].GridNo)

return data
  });
  

  let filterDatas = inputProp.GridsDataSources.value.map((obj, index) => 
    obj.GridNo == args.data.GridNo && obj.SerialNo ==  args.data.SerialNo
      ? { 
          ...obj,
        
    BudgetItemID: args.data.BudgetItemID || '',
    BudgetItem: args.data.BudgetItem || '',
    Quantity: args.data.Quantity || 0,
    Rate: args.data.Rate || 0,
    Percentage: args.data.Percentage || 0,
    Amount: args.rowData.Amount || 0,
    ActualAmount: args.data.ActualAmount || 0,
        } 
      : obj
  );
  console.log(filterDatas);
  
  setInputProps((prevValues) =>({
    ...prevValues,
    ['GridsDataSources'] : {...prevValues['GridsDataSources'] ,value:filterDatas}
  }));   
  // getYarnCalculation(inputProp.CustomerOrderNo.value.id)
  // getOtherCalculation(inputProp.CustomerOrderNo.value.id)
  // getUpperSummaryCalculation(inputProp.CustomerOrderNo.value.id)
 
   props.sendDetails(filterDatas)
  }, 1000); 
}
let  data = {
  EntryID:inputProp.EntryID.value,	
  EntryDate:inputProp.EntryDate.value,
  ExportOrderNo:inputProp.CustomerOrderNo.value.id,
  UserID:SecurityService.getLoggedInUserId(),
  UpdationDate:moment().format('DD-MMM-YY'),
  //DETAIL
  BudgetItemID: args.data.BudgetItemID || '',
  BudgetItem: args.data.BudgetItem || '',
  Quantity: args.data.Quantity || 0,
  Rate: args.data.Rate || 0,
  Percentage: args.data.Percentage || 0,
  Amount: args.rowData.Amount || 0,
  ActualAmount: args.data.ActualAmount || 0,
  BudgetingDetailID:args.data.BudgetingDetailID,
    params:{
      BudgetCategoryID:args.data.GridNo,
      EntryID:inputProp.EntryID.value


  } 
}
if((props.isAdd == false || inputProp.PopupMode.value == 'EDIT') && args.action == 'edit' ){
    
  const response = await BudgetingService.updateWithDetail(data);
          console.log(response)
          getGridSum(response.data.Recordsets.recordsets[0] , args.data.GridNo)
          getYarnCalculation(inputProp.CustomerOrderNo.value.id)
          getOtherCalculation(inputProp.CustomerOrderNo.value.id)
       
          await setDataSourceState(response.data.Recordsets.recordsets[0])
   
}
if((props.isAdd == false || inputProp.PopupMode.value == 'EDIT') && args.action == 'add'){
  const response = await BudgetingService.addDetail(data);
  console.log(response)
  getGridSum(response.data.Recordsets.recordsets[0] , args.data.GridNo)
  getYarnCalculation(inputProp.CustomerOrderNo.value.id)
  getOtherCalculation(inputProp.CustomerOrderNo.value.id)

  await setDataSourceState(response.data.Recordsets.recordsets[0]);
  setTimeout(() => {
    let gridId =  args.data.GridNo == 1 ? "BudgetingAccessoryDetail" :  args.data.GridNo ==2 ? "BudgetingPackingItemDetail" : "BudgetingExpenseDetail"
     document.getElementById(`${gridId}Grid_add`).click()
   }, 500);
}
  }
}



// Usage in your main component



  return (
    <div onKeyDown={(e)=>e.stopPropagation()}>
      <div className='row'>
    <div className='col-sm-10'>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={props} title={`Budgeting ${props.isAdd == true || inputProps.PopupMode.value == 'ADD' ? `Add` : `Edit`}`} Inputs={inputsList}/>
      {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}
      <div id='BudgetingAccessoryDetail-Grid'>
      <IrtizaDynamicInputGrid
        Id='BudgetingAccessoryDetail'
        
        ColumnsList={[
          { field:"GridNo",headerText:'Grid ID',width:'115px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false,defaultValue:1}]},
          { field:"SerialNo",headerText:'S No.',width:'115px',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false}]},
          
          { field:"BudgetItemID",headerText:'Budgeting ID' ,width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
          { field:"BudgetItem",headerText:'Accessory',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[{'editType':'dropdownedit',edit:{
            caption:'Accessory' ,source:{type:"Route",dataSource:'BudgetItemAccessory'} , field:{id:'BudgetItemID',value:'BudgetItem'}, filter:{},
            // select:{source:{type:'Function',dataSource:{function:invoiceService.getMultiDropDownSource , params :[{type:'Value',source:'Stock'},{type:'Value',source:'0'},{type:'Value',source:'01-JUN-24'},{type:'Value',source:moment().format('DD-MMM-YY')},{type:'Column',source:'BrandID'}] , dropDownKey:'ProductID'}}},
          }
          }]},
          
          { field:"Quantity",headerText:'Quantity',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0','editType':'numericedit',defaultValue:0}]},
          { field:"Rate",headerText:'Rate',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n2','editType':'numericedit',defaultValue:0}]},
          { field:"Percentage",headerText:'%',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{visible:false,defaultValue:0}]},
          { field:"Amount",headerText:'Amount',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0','editType':'numericedit',allowEditing:false}]},
          { field:"ActualAmount",headerText:'Actual Amount',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{visible:false,defaultValue:0}]}
        ]}

        GridDataSource= {[
          {
        DataSourceType:inputProps.CallGridDataSource.value ? 'Function' : 'REST',
        DataSource:  ()=>  callGridDataSource(1) ,
        // CreateColumns: [{columnName:'GridNo',columnValue:1}]
         }]
  }
        DefaultSortedColumnName={'SerialNo' }
      
        ListActionComplete={addActionComplete}
        ToolbarClicking ={toolbarClicking}
        SelectRowByID={inputProps.SelectRowByID.value}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
        AllowTemplate={false}
        ToolbarOption={['Add','Edit',props.isAdd == true || inputProps.PopupMode.value == 'ADD'  ? {   text: `Delete`, tooltipText: "Delete",mustSelectRow:true ,id: "DeleteAdd", disable:false } : 'Delete',        
'Update','Cancel']}
        AllowGrouping={false}
        AllowExcelExport={false} 
        AllowPdfExport={false} 
        ShowColumnChooser={false}
        AllowPaging={false}
        AllowDataBound={false}
        // ListSecurity={}
        AddSecurity={'Budgeting'}
        EditSecurity={'Budgeting'}
        DeleteSecurity={'Budgeting'}
        DefaultSortedColumnSort={'Descending'}
        FilterColumns={[]} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
        GroupColumns={[]} 
        ListDelete={[{ TableName:'BudgetingDetail' ,TableID:'BudgetingDetailID'}]}
        DeleteType={'hard'} 
        GridEditSettingMode={'Normal'}
        GridEditSettingHeaderTemplate={'<p></p>'}
        // GridSumColumns={[]}
        // AllowGridSum={true}
        // footerSumCaption={[{
        //   ColumnName:'TransferQty - sum',
        //   Caption:'Qty'
        // }]}
            {...props}
            ></IrtizaDynamicInputGrid>
            </div>
      
      <div id='BudgetingPackingItemDetail-Grid'>
      <IrtizaDynamicInputGrid
        Id='BudgetingPackingItemDetail'
        
        ColumnsList={[
          { field:"GridNo",headerText:'Grid ID',width:'115px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false,defaultValue:2}]},
          { field:"SerialNo",headerText:'S No.',width:'115px',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false}]},
          
          { field:"BudgetItemID",headerText:'Budgeting  ID' ,width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
          { field:"BudgetItem",headerText:'Packing',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[{'editType':'dropdownedit',edit:{
            caption:'Packing' ,source:{type:"Route",dataSource:'BudgetItemPacking'} , field:{id:'BudgetItemID',value:'BudgetItem'}, filter:{},
            // select:{source:{type:'Function',dataSource:{function:invoiceService.getMultiDropDownSource , params :[{type:'Value',source:'Stock'},{type:'Value',source:'0'},{type:'Value',source:'01-JUN-24'},{type:'Value',source:moment().format('DD-MMM-YY')},{type:'Column',source:'BrandID'}] , dropDownKey:'ProductID'}}},
          }
          }]},
          
          { field:"Quantity",headerText:'Quantity',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0','editType':'numericedit',defaultValue:0}]},
          { field:"Rate",headerText:'Rate',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n2','editType':'numericedit',defaultValue:0}]},
          { field:"Percentage",headerText:'%',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{visible:false,defaultValue:0}]},
          { field:"Amount",headerText:'Amount',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0','editType':'numericedit',allowEditing:false}]},
          { field:"ActualAmount",headerText:'Actual Amount',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{visible:false,defaultValue:0}]}
        ]}
        GridDataSource= {[
          {
        DataSourceType:inputProps.CallGridDataSource.value ? 'Function' : 'REST',
        DataSource:  ()=>  callGridDataSource(2) ,
        // CreateColumns: [{columnName:'GridNo',columnValue:2}]
         }]
  }
        DefaultSortedColumnName={'SerialNo' }
      
        ListActionComplete={addActionComplete}
        ToolbarClicking ={toolbarClicking}
        SelectRowByID={inputProps.SelectRowByID.value}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
        AllowTemplate={false}
        ToolbarOption={['Add','Edit',props.isAdd == true || inputProps.PopupMode.value == 'ADD' ? {   text: `Delete`, tooltipText: "Delete",mustSelectRow:true ,id: "DeleteAdd", disable:false } : 'Delete','Update','Cancel']}
        AllowGrouping={false}
        AllowExcelExport={false} 
        AllowPdfExport={false} 
        ShowColumnChooser={false}
        AllowPaging={false}
        AllowDataBound={false}
        // ListSecurity={}
        AddSecurity={'Budgeting'}
        EditSecurity={'Budgeting'}
        DeleteSecurity={'Budgeting'}
        DefaultSortedColumnSort={'Descending'}
        FilterColumns={[]} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
        GroupColumns={[]} 
        ListDelete={[{ TableName:'BudgetingDetail' ,TableID:'BudgetingDetailID'}]}
        DeleteType={'hard'} 
        GridEditSettingMode={'Normal'}
        GridEditSettingHeaderTemplate={'<p></p>'}
        // GridSumColumns={[]}
        // AllowGridSum={true}
        // footerSumCaption={[{
        //   ColumnName:'TransferQty - sum',
        //   Caption:'Qty'
        // }]}
            {...props}
            ></IrtizaDynamicInputGrid>
            </div>
      
      <div id='BudgetingExpenseDetai-Grid'>
      <IrtizaDynamicInputGrid
        Id='BudgetingExpenseDetail'
        
        ColumnsList={[
          { field:"GridNo",headerText:'Grid ID',width:'115px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false,defaultValue:3}]},
          { field:"SerialNo",headerText:'S No.',width:'115px',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false}]},
          
          { field:"BudgetItemID",headerText:'Budgeting ID' ,width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
          { field:"BudgetItem",headerText:'Expense',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[{'editType':'dropdownedit',edit:{
            caption:'Expense' ,source:{type:"Route",dataSource:'BudgetItemExpense'} , field:{id:'BudgetItemID',value:'BudgetItem'}, filter:{},
            // select:{source:{type:'Function',dataSource:{function:invoiceService.getMultiDropDownSource , params :[{type:'Value',source:'Stock'},{type:'Value',source:'0'},{type:'Value',source:'01-JUN-24'},{type:'Value',source:moment().format('DD-MMM-YY')},{type:'Column',source:'BrandID'}] , dropDownKey:'ProductID'}}},
          }
          }]},
          
          { field:"Quantity",headerText:'Quantity',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0','editType':'numericedit',defaultValue:0}]},
          { field:"Rate",headerText:'Rate',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n2','editType':'numericedit',defaultValue:0}]},
          { field:"Percentage",headerText:'%',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0','editType':'numericedit',defaultValue:0}]},
          { field:"Amount",headerText:'Amount',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0','editType':'numericedit',allowEditing:false}]},
          { field:"ActualAmount",headerText:'Actual Amount',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0','editType':'numericedit',defaultValue:0}]}
        ]}
        GridDataSource= {[
          {
        DataSourceType:inputProps.CallGridDataSource.value ? 'Function' : 'REST',
        DataSource:  ()=>  callGridDataSource(3) ,
        // CreateColumns: [{columnName:'GridNo',columnValue:3}]        
       }]
  }
        DefaultSortedColumnName={'SerialNo' }
      
        ListActionComplete={addActionComplete}
        ToolbarClicking ={toolbarClicking}
        SelectRowByID={inputProps.SelectRowByID.value}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
        AllowTemplate={false}
        ToolbarOption={['Add','Edit',props.isAdd == true || inputProps.PopupMode.value == 'ADD' ? {   text: `Delete`, tooltipText: "Delete",mustSelectRow:true ,id: "DeleteAdd", disable:false } : 'Delete','Update','Cancel']}
        AllowGrouping={false}
        AllowExcelExport={false} 
        AllowPdfExport={false} 
        ShowColumnChooser={false}
        AllowPaging={false}
        AllowDataBound={false}
        // ListSecurity={}
        AddSecurity={'Budgeting'}
        EditSecurity={'Budgeting'}
        DeleteSecurity={'Budgeting'}
        DefaultSortedColumnSort={'Descending'}
        FilterColumns={[]} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
        GroupColumns={[]} 
        ListDelete={[{ TableName:'BudgetingDetail' ,TableID:'BudgetingDetailID'}]}
        DeleteType={'hard'} 
        GridEditSettingMode={'Normal'}
        GridEditSettingHeaderTemplate={'<p></p>'}
        // GridSumColumns={[]}
        // AllowGridSum={true}
        // footerSumCaption={[{
        //   ColumnName:'TransferQty - sum',
        //   Caption:'Qty'
        // }]}
            {...props}
            ></IrtizaDynamicInputGrid>
            </div>
      
            </div>

            
            <div className='col-sm-2'>
            <StructuredGenerate   mainProps={props} title={``} Inputs={inputsCalculationList}/>
</div>
            </div>
</div>
  );
}; 

export default BudgetingAdd;
